var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#010101;}\r\n\t.st2{display:inline;fill:#FFFFFF;}\r\n\t.st3{display:inline;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st4{display:inline;}\r\n\t.st5{font-family:'MyriadPro-Bold';}\r\n\t.st6{font-size:15.3654px;}\r\n\t.st7{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.9,
    y: 0.8,
    fill: "currentColor",
    width: 19.8,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 0.8,
    fill: "currentColor",
    width: 19.8,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 2.7,
    fill: "currentColor",
    width: 16.5,
    height: 20.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 2.7,
    fill: "currentColor",
    width: 16.5,
    height: 20.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 25.7,
    fill: "currentColor",
    width: 6.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 25.7,
    fill: "currentColor",
    width: 6.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "3.9,25.7 9.6,25.7 15.8,31.9 23.7,31.9 23.7,34.2 14.9,34.2 8.5,27.8 3.9,27.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "3.9,32.6 9.7,32.6 15.9,38.8 23.7,38.8 23.7,41 14.9,41 8.5,34.6 3.9,34.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "44.5,32.6 38.8,32.6 32.6,38.8 24.7,38.8 24.7,41 33.5,41 39.9,34.6 44.5,34.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "44.5,25.7 38.8,25.7 32.6,31.9 24.7,31.9 24.7,34.2 33.5,34.2 39.9,27.8 44.5,27.8"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.4,15.9v3.9h6c0,0,1-0.2,1.3,1.1v9.9c0,0,0,0.9-1.2,1.1h-6v3.8c0,0-0.5,1.6-2.2,0.7l-9.7-9.9 c0,0-0.7-0.8,0.3-1.8l9.5-9.4C11.3,15.2,12.9,14.3,13.4,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.3,25.7L11,19v2.3c0,0,0.3,0.9,1.2,0.9h6v7.3H12c0,0-0.9,0.2-1,1v2.1L4.3,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M35.1,15.9v3.9h-6c0,0-1-0.2-1.3,1.1v9.9c0,0,0,0.9,1.2,1.1h6v3.8c0,0,0.5,1.6,2.2,0.7l9.6-9.9 c0,0,0.7-0.8-0.3-1.8l-9.5-9.4C37.3,15.2,35.7,14.3,35.1,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M44.3,25.7L37.6,19v2.3c0,0-0.3,0.9-1.2,0.9h-6v7.3h6.2c0,0,0.9,0.2,1,1v2.1L44.3,25.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7,17.2l1.9-0.9l0.3-1.6c0,0,0.2-1,1-1h1.8c0,0,0.8,0.2,0.9,0.9l0.3,1.7l1.8,0.8l1.5-1c0,0,0.7-0.4,1.2,0.1l1.4,1.6 c0,0,0.3,0.5-0.1,1l-0.9,1.3l0.9,2l1.9,0.3c0,0,0.6,0.3,0.7,1v1.7c0,0-0.3,0.8-0.9,0.9l-1.5,0.2l-0.8,1.9l0.9,1.4 c0,0,0.3,0.3,0.2,1l-1.5,1.6c0,0-0.3,0.3-1.1,0l-1.5-1L26.8,32l-0.4,1.8c0,0-0.3,0.7-0.7,0.7h-2c0,0-0.7-0.3-0.8-0.9L22.6,32 l-1.9-0.8L19,32.4c0,0-0.7,0.2-1-0.3l-1.4-1.5c0,0-0.2-0.9,0.2-1.2l0.9-1.1l-0.9-2l-2-0.3c0,0-0.5-0.3-0.6-1v-1.9 c0,0,0.3-0.6,1.1-0.9l1.5-0.2l0.9-2l-1.1-1.6c0,0-0.2-0.6,0-1l1.6-1.5c0,0,0.9-0.2,1.2,0.2L20.7,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7,1.4c0,0,19-0.3,19.9,20.5c0,0,1.3,1,1.4,2.6v5.7c0,0-0.1,2.9-3.6,3.5c0,0-4,1.3-4.6-3.5l0.2-6.6c0,0,0.2-1.9,2.2-2.6 c0,0,0-11.3-11.5-14.6c0,0-9.7-2.5-15.5,4.8c0,0-3.3,3.1-3.7,9.7c0,0,2.1,0.5,2.5,3.2l0,6.3c0,0-0.1,1.7-1.5,2.8 c0,0,0.3,5.2,5.4,7.3c0,0,2,1,4.5,0.6c0,0,0.7-1.1,2.2-1.1l4.4,0.1c0,0,1.7,0.2,1.9,1.9l0,3.1c0,0-0.3,1.9-2.3,1.9l-4.5,0 c0,0-1.3,0.1-1.8-1.3c0,0-6,1.1-11-4.3c0,0-3.3-3.1-3.4-8.2c0,0-2.4-0.7-2.2-3.9l0-5.3c0,0,0.2-1,1.4-2.2c0,0-0.6-6.7,4.1-12.7 C8.9,9.1,13.3,1.6,24.7,1.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 24.6,
    cy: 24,
    r: 3.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallService);
export default __webpack_public_path__ + "static/media/CallService.640fb001484043c071770f51c9e6e503.svg";
export { ForwardRef as ReactComponent };